import { Injectable } from '@angular/core';
import { PlatformService } from './platform.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ShareOnService {
  /**
   *
   */
  constructor(private platformService: PlatformService) {}

  /**Share Now */
  shareNow(fullUrl: string) {
    console.log(fullUrl);

    window.open(fullUrl, '', 'width=700,height=400');
  }

  // /*** Share Url On Facebook*/
  facebook(url: string) {
    this.shareNow(`https://www.facebook.com/sharer.php?u=${url}`);
  }

  // /*** Share Url On Twitter*/
  // twitter(url: string, text: string='') { this.shareNow(`https://twitter.com/intent/tweet?url=${url}&text=${url}:${text}`); };
  // /*** Share Url On Linkedin*/
  // linkedin(url: string, text: string='') { this.shareNow(`https://www.linkedin.com/shareArticle?url=${url}&title=${text}`); };
  // /*** Share Url On Reddit*/
  // reddit(url: string, text: string='') { this.shareNow(`https://reddit.com/submit?url=${url}&title=${text}`); };

  /*** Share Url On Messanger*/
  messenger(url: string) {
    if (this.platformService.isMobile)
      this.shareNow(
        `fb-messenger://share/?link=${url}&app_id=${environment.facebook.app_id}`,
      );
    else
      this.shareNow(
        `https://www.facebook.com/dialog/send?link=${url}&app_id=${environment.facebook.app_id}&redirect_uri=${url}`,
      );
  }

  /*** Share Url On Whatsapp*/
  whatsapp(url: string) {
    if (this.platformService.isMobile)
      this.shareNow(`whatsapp://send?text=${url}`);
    else this.shareNow(`https://web.whatsapp.com/send?text=${url}`);
  }

  // /*** Share Url On Telegram*/
  // telegram(url: string, text: string='') { this.shareNow(`https://t.me/share/url?url=${url}&text=${text}&to=`); };
  // /*** Share Url On Gmail*/
  // gmail(url: string, text: string='') { this.shareNow(`https://mail.google.com/mail/?view=cm&su=${text}&body=${url}:${text}&to=&su=&bcc=&cc=`); };
  // /*** Share Url On Email*/
  // email(url: string, text: string='') { this.shareNow(`mailto:?to=&subject=${text}&body=${url}: ${text}`); };
  // /*** Share Url On Blogger*/
  // blogger(url: string, text: string='') { this.shareNow(`https://www.blogger.com/blog-this.g?u=${url}&t=${text}&n=${text}`); };
  // /*** Share Url On Wordpress*/
  // wordpress(url: string, text: string='') { this.shareNow(`http://wordpress.com/wp-admin/press-this.php?u=${url}&t=${text}&s=${text}&i=`); };
}
